import axios from "axios";
import Config from "@/config"

function me(accesstoken) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: {
                "populate": 'family_members,achieved,achieved.achievement,ingredients_allergies.labels,not_liked_ingredients.labels,avatar,appliances.appliance_type.media,appliances.appliance_type.category,appliances,appliances.history,shopping_list,shopping_list.ingredient,shopping_list.unit,shopping_list.ingredient.labels,shopping_list.unit.labels,shopping_list.ingredient.default_storage_type,shopping_list.ingredient.media',
            },
        };
        return axios
            .get(
                Config.proxy + Config.url("me"),
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }


function update(accesstoken, id, name, surname, email, address_country) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };
        return axios
            .put(
                Config.proxy + Config.url("usersUpdate") +"/"+id ,
                {
                    name, surname, email, address_country
                },
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }

    // updateFamilyMembers
    function updateFamilyMembers(accesstoken, id, family_members) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };
        return axios
            .put(
                Config.proxy + Config.url("usersUpdate") +"/"+id,
                {family_members},
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }

    function updateProfileInformation(accesstoken, id, ingredientsAllergies, notLikedIngredients, preferred_course, sweet_or_savoury, preferred_cooking_meal) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} }
        };
        let p =  {
            ingredients_allergies: ingredientsAllergies,
            not_liked_ingredients: notLikedIngredients,
            preferred_course, 
            sweet_or_savoury, 
            preferred_cooking_meal

        };
        console.log(p);

        return axios
            .put(
                Config.proxy + Config.url("usersUpdate") +"/"+id,
                {
                    ingredients_allergies: ingredientsAllergies,
                    not_liked_ingredients: notLikedIngredients,
                    preferred_course, 
                    sweet_or_savoury, 
                    preferred_cooking_meal

                },
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    function getLikedRecipesbyUserWithLabels(accesstoken, locale, idUser) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: {
                "fields": "email",
                "populate[liked_recipes][populate][ingredients][populate][ingredient][populate]": "labels",
                "populate[liked_recipes][populate][ingredients][populate][unit][populate]": "labels",
                "populate[liked_recipes][fields]": "key,cooking_time,prep_time,difficulty",
                "populate[liked_recipes][populate][labels][fields]": "title,locale,key",
                "populate[liked_recipes][populate][media][fields]": "url,name",
                "populate[liked_recipes][populate]": "category",
                
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("user")+"/"+idUser,
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    function getListPublicUsers(user_id) {
        const options = {
            headers: { ...Config.subscriptionKey() },
            params: {
                "filters[user_id][$eq]": user_id,
                "fields": "username,email,user_id",
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("publicUsers"),
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    function addToFavorite(user_id, accesstoken, recipe_ids) {
        const options = {
            headers: { ...Config.headers(accesstoken) }
        };
        return axios
            .put(
                Config.proxy + Config.url("user") + "/" + user_id,
                {
                    "liked_recipes": recipe_ids
                },
                options
            )
            .then(res => res.data)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    export { me, update, updateFamilyMembers, updateProfileInformation, getLikedRecipesbyUserWithLabels, getListPublicUsers, addToFavorite} ;